import { render, staticRenderFns } from "./WarningSaveAndCloseEnvelope.vue?vue&type=template&id=7f20e194&lang=pug"
import script from "./WarningSaveAndCloseEnvelope.vue?vue&type=script&lang=js"
export * from "./WarningSaveAndCloseEnvelope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports